'use client';
import { em, rem } from '../units/units.js';

var concat = function(unit, sizes) {
    if (sizes.length) {
        switch(unit){
            case "rem":
                return sizes.map(function(size) {
                    return rem(size);
                }).join(" ");
            case "em":
                return sizes.map(function(size) {
                    return em(size);
                }).join(" ");
            default:
                return sizes.map(function(size) {
                    return "" + size + unit;
                }).join(" ");
        }
    }
    return "0";
};
var size = function() {
    for(var _len = arguments.length, sizes = new Array(_len), _key = 0; _key < _len; _key++){
        sizes[_key] = arguments[_key];
    }
    return concat("px", sizes);
};
size.rem = function() {
    for(var _len = arguments.length, sizes = new Array(_len), _key = 0; _key < _len; _key++){
        sizes[_key] = arguments[_key];
    }
    return concat("rem", sizes);
};
size.em = function() {
    for(var _len = arguments.length, sizes = new Array(_len), _key = 0; _key < _len; _key++){
        sizes[_key] = arguments[_key];
    }
    return concat("em", sizes);
};
size.pct = function() {
    for(var _len = arguments.length, sizes = new Array(_len), _key = 0; _key < _len; _key++){
        sizes[_key] = arguments[_key];
    }
    return concat("%", sizes);
};
size.vh = function() {
    for(var _len = arguments.length, sizes = new Array(_len), _key = 0; _key < _len; _key++){
        sizes[_key] = arguments[_key];
    }
    return concat("vh", sizes);
};
size.vw = function() {
    for(var _len = arguments.length, sizes = new Array(_len), _key = 0; _key < _len; _key++){
        sizes[_key] = arguments[_key];
    }
    return concat("vw", sizes);
};
size.fr = function() {
    for(var _len = arguments.length, sizes = new Array(_len), _key = 0; _key < _len; _key++){
        sizes[_key] = arguments[_key];
    }
    return concat("fr", sizes);
};

export { size };
